import React from 'react'
import ReactDOM from 'react-dom'
import ShowCard from './views/showCard'
import SelectModel from './views/selectModel'
import EditCard from './views/EditCard'
import eventBus from '../../../../../util/eventBus'
import "./style/style.less"

(function (KDApi) {
  function MyComponent(model) {
    this._setModel(model)
  }

  MyComponent.prototype = {
    _setModel: function (model) {
      this.model = model
    },
    init: function (props) {
      console.log('-----init-----', props)
      setHtml(this.model, props)
    },
    update: function (props) {
      console.log('-----update-----', props)
      eventBus.pub(this.model, 'update', props)
    },
    destoryed: function () {
      // console.log('-----destoryed', this.model)
      ReactDOM.unmountComponentAtNode(this.model.dom)
    }
  }

  var setHtml = function (model, primaryProps) {
    KDApi.loadFile('./css/index.css', model, () => {

      class Root extends React.Component {
        constructor(props) {
          super(props)

          const data = props?.customProps?.data ?? null
          const operate = data?.operate ?? ""
          const { carddimensionid = "" } = data.carddimension

          // 临时方案-s
          const defaultColorEG = { backgroundcolor: "#fff", bordercolor: "#ccc", topbordercolor: "" }
          switch (carddimensionid + "") {
            case "1010":  // 行政组织
              defaultColorEG.topbordercolor = "#276FF5"
              break;
            case "1110":  // 岗位
              defaultColorEG.backgroundcolor = "#f4f8fe"
              defaultColorEG.bordercolor = "#5582f3"
              break;
            case "1020":  //项目团队
              defaultColorEG.topbordercolor = "#1BA854"
              break;
          }
          data.defaultColor = defaultColorEG
          // 临时方案-e

          const { defaultColor } = data

          // console.log("init", data);
          console.log("defaultColor", defaultColor);

          let status = 1
          let currCardModel = null
          let lock = false

          switch (operate) {
            case "cardcontentid":
              // 新增
              break;
            case "lock":
              // 查看
              status = 2
              currCardModel = this.transModel(data?.list ?? [])
              lock = true
              break;
            case "unlock":
              // 编辑（复制）
              status = 2
              currCardModel = this.transModel(data?.list ?? [])
              break;
          }

          this.state = {
            customProps: props.customProps,
            model: props.model,
            status, //1：选择模板 2：查看卡片 3：编辑模板
            hasCard: 0,//0：没有卡片 1：生成卡片
            currCardModel,
            lock,
            defaultColor,
            cardStyle: defaultColor
          }

        }

        componentDidMount() {
          const { model } = this.state
          this.updateSub = eventBus.sub(model, 'update', (updateProps) => {
            const operate = updateProps?.data?.operate ?? ""
            console.log("update operate", operate);

            switch (operate) {
              case "cardcontentid":
                // 切换卡片维度
                this.setState({
                  customProps: updateProps,
                  status: 1,//1：选择模板 2：查看卡片 3：编辑模板
                  hasCard: 0,//0：没有卡片 1：生成卡片
                  currCardModel: null,
                  lock: false
                })

                break;
              case "unlock":
                // 编辑（查看->修改）
                this.setState({
                  customProps: updateProps,
                  status: 2,
                  lock: false
                })
                break;
            }



          })
        }

        componentWillUnmount() {
          eventBus.unsub(this.updateSub)
        }

        // 后端卡片字段列表->前端格式
        transModel = list => {
          return list.map(item => {
            return {
              aftercontent: item.aftercontent ?? "",
              beforecontent: item.beforecontent ?? "",
              align: parseInt(item.fontjustification),
              bold: item.bold === 1,
              fontSize: item.wordsize,
              h: item.high,
              i: item.cardcontentid,
              name: item.name,
              showInfo: (item?.sampledates ?? [])[0],
              w: item.wide,
              x: item.xcoordinate,
              y: item.ycoordinate,
            }
          })
        }

        selectModal = (modalItem, cardStyle = this.state.defaultColor) => {
          console.log("设置卡片", modalItem, cardStyle);
          this.setState({
            currCardModel: modalItem,
            cardStyle,
            status: 2,
            hasCard: 1,
          })

          // 标记状态：已经选了字段（模板）并保存
          this.state.model.invoke("isHadContent", modalItem.length > 0 ? "1" : "0")

          this.saveCard(modalItem)
        }

        reSelecetCard = () => {
          this.setState({
            status: 1
          })
        }

        backShowCard = () => {
          this.setState({
            status: 2
          })
        }

        editCancel = () => {
          this.setState({
            status: 2
          })
          this.state.model.invoke("edit", "0")
        }

        editCardModel = () => {
          this.setState({
            status: 3
          })
          this.state.model.invoke("edit", "1")
        }

        saveCard = modalItem => {

          const fields = modalItem.map(item => {
            return {
              cardcontentid: item.i,
              beforecontent: item.beforecontent,
              aftercontent: item.aftercontent,
              rows: "2",
              wordsize: item.fontSize + "",
              bold: item.bold ? 1 : 0,
              xcoordinate: item.x,
              ycoordinate: item.y,
              wide: item.w,
              high: item.h,
              fontjustification: item.align,
            }
          })

          this.state.model.invoke("isHadContent", fields.length > 0 ? "1" : "0")

          console.log("保存", fields);

          if (fields.length > 0) {
            this.state.model.invoke("edit", "0")

            this.state.model.invoke("save", fields)
          }
        }

        I18N = key => KDApi.getLangMsg(model, key)

        render() {
          const { customProps, model, status, hasCard, currCardModel, lock, cardStyle, defaultColor } = this.state

          const { I18N } = this

          return (
            <div className="card-filt-container">
              <div className="card-nav-bar">
                <div className="title">{I18N("main.title")}</div>
                {(status === 1 && hasCard === 1) && (
                  <div className="op-status" onClick={this.backShowCard}>{I18N("op.back")}</div>
                )}
                {(status === 2 && hasCard === 1) && (
                  <div className="op-status" onClick={this.reSelecetCard}>{I18N("op.reselect")}</div>
                )}
              </div>
              <div className="main-wrapper">
                {
                  status === 1 && (<SelectModel model={model} customProps={customProps.data}
                    selectModal={this.selectModal} defaultColor={defaultColor} I18N={I18N} />)
                }
                {
                  status === 2 && (<ShowCard model={model} editCardModel={this.editCardModel}
                    currCardModel={currCardModel} lock={lock} cardStyle={cardStyle} I18N={I18N} />)
                }
                {
                  status === 3 && (<EditCard
                    model={model} editCancel={this.editCancel}
                    selectModal={this.selectModal} fields={customProps.data.fields}
                    currCardModel={currCardModel} cardStyle={cardStyle} I18N={I18N} />)
                }
              </div>
            </div>
          )
        }
      }

      ReactDOM.render(<Root model={model} customProps={primaryProps} />, model.dom)

    })
  }

  // 注册自定义组件
  KDApi.register('kdchartPrecard', MyComponent, { isMulLang: true })
})(window.KDApi)
